<template>
  <v-navigation-drawer
    v-model="drawer"
    color="#f5f5f5"
    app
    clipped
    flat
  >
    <v-list>
      <v-list-item v-if="project">
        <v-avatar size="40" dark class="rounded" tile>
          <v-img :src="project.iconUrl"></v-img>
        </v-avatar>
      </v-list-item>

      <v-list-item v-if="project">
        <v-list-item-content>
          <v-list-item-title class="text-h6">
              <span class="text-lowercase text-capitalize">{{
                  project.name
                }}</span>
          </v-list-item-title>
          <v-list-item-subtitle
          >Inicio: {{ formatDate(project.startDate) }}</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider v-if="project"></v-divider>
    <v-list v-if="project" nav dense>
      <v-list-item
        link
        :to="'/proyecto/' + project.id + '/ordenes-trabajo-proyecto'"
      >
        <v-list-item-icon>
          <v-icon color="primary">mdi-play-network</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Ordenes de trabajo PWO</v-list-item-title>
      </v-list-item>

      <v-list-item
        link
        :to="'/proyecto/' + project.id + '/ordenes-trabajo-staff'"
      >
        <v-list-item-icon>
          <v-icon color="primary">mdi-account-clock</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Ordenes de trabajo SWO</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import MENU_ITEMS_CONSTANTS from '@/constants/MenuItemsConstants'
import PERMISSIONS from '../../constants/PermissionConstants'
import sessionMixin from '../../mixins/sessionMixin'
import { PROJECT_URL } from '../../constants/ServicesConstants'
import errorHandlerMixin from '../../mixins/errorHandlerMixin'
import loaderMixin from '../../mixins/loaderMixin'
import crudServiceMixin from '../../mixins/crudServiceMixin'
import notificationMixin from '../../mixins/notificationMixin'
import dateMixin from '../../mixins/dateMixin'

export default {
  name: 'ProjectDrawer',
  created () {
    this.getProject(this.$route.params.projectId)
  },
  data () {
    return {
      drawer: true,
      menuItems: MENU_ITEMS_CONSTANTS,
      project: null,
      permissions: PERMISSIONS
    }
  },
  mixins: [
    sessionMixin,
    errorHandlerMixin,
    loaderMixin,
    crudServiceMixin,
    notificationMixin,
    dateMixin
  ],
  methods: {
    getProject (projectId) {
      if (projectId) {
        this.showLoader()
        this.get(PROJECT_URL + '/' + projectId)
          .then((response) => {
            this.hideLoader()
            this.project = response.data
          })
          .catch((e) => {
            this.errorHandler(e)
            this.hideLoader()
          })
      }
    },
    toggleDrawer () {
      this.drawer = !this.drawer
    }
  }
}
</script>
